import { NgClass } from '@angular/common';
import { Component, computed, input, output } from '@angular/core';
import { NgIcon } from '@ng-icons/core';
import { Button } from '../button/button';

@Component({
  selector: 'ui-dropzone-file',
  imports: [NgIcon, Button, NgClass],
  templateUrl: './dropzone-file.html',
})
export class DropzoneFile {
  progress = input.required<number>();
  titleText = input.required<string>();
  subtitle = input.required<string>();
  error = input<unknown | null>(null);
  transitionDuration = input<number>(500);

  clickRemove = output();
  clickRetry = output();

  protected progressPercent = computed(() => {
    const p = this.progress();
    return Math.max(0, Math.min(100, p));
  });
}
